import { useIntl, defineMessages } from 'react-intl';

const messages = defineMessages({
    resultLengthPro: {
        id: 'listing.resultLengthPro',
        defaultMessage:
            '{count} products found, including {pro_count} pro products',
        description: 'Number of pro products',
    },
    resultLength: {
        id: 'listing.resultLength',
        defaultMessage:
            '{count, plural, =0 {# product found} one {# product found} other {# products found}}',
        description: 'Number of products',
    },
    resultLengthMoreThanLimit: {
        id: 'listing.resultLengthLimit',
        defaultMessage: 'More than 500 products found',
        description: 'More than 500 products',
    },
});

const useResultLengthLabel = (count, shouldShowProProducts, proCount) => {
    const intl = useIntl();

    if (shouldShowProProducts && count > 1 && proCount > 1) {
        return intl.formatMessage(messages.resultLengthPro, {
            count,
            pro_count: proCount,
        });
    }
    if (count < 500) {
        return intl.formatMessage(messages.resultLength, { count });
    }
    return intl.formatMessage(messages.resultLengthMoreThanLimit);
};

export default useResultLengthLabel;
